import { Popper } from "@/components/atoms/Popper";
import { NodeList } from "@/components/organisms/Node/NodeList";
import { Objects } from "@/objects";
import { State } from "@/state";

export function ThreadTogglePopper({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Popper
      anchor={children}
      placement={"top-start"}
      floatingStyle={{
        minWidth: "200px",
        height: "min-content",
      }}
    >
      <NodeList
        {...Objects["ThreadObject"].getReferenceValueOptions()}
        onSelectOption={(option: any) => {
          State.getState().openThreadTab(option.id, {
            label: option.name ?? option.label,
          });
        }}
        size="md"
      />
    </Popper>
  );
}
